import Components from "slotworks/components/components";
import bonusSymbolSetup from "utils/bonus-symbol-setup";
import MCSymbolCountBehaviour from "components/matrix/symbol/behaviours/mc-symbol-count-behaviour";

class AttachMCSymbolCount {

    public setupBehaviour() {
        Components.matrix.getAllSymbols().forEach((symbol) => {
            const behaviour = new MCSymbolCountBehaviour(symbol);
            behaviour.validSymbols = bonusSymbolSetup.getSymbolIds();
            symbol.addBehaviour(behaviour);
        });
    }

    public tearDownBehaviour() {
        Components.matrix.getAllSymbols().forEach((symbol) => {
            const behaviour = symbol.getBehaviourByName<MCSymbolCountBehaviour>("MCSymbolCount");
            symbol.removeBehaviour(behaviour);
        });
    }
}

export default new AttachMCSymbolCount();
